var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"portal-footer portal-footer--home"},[_c('div',{staticClass:"portal-footer__inner portal-footer__inner--home"},[_c('p',[_vm._v("版权所有 © 全国社会艺术水平等级考试")])])])
}]

export { render, staticRenderFns }